module.exports = __webpack_public_path__ + "static/media/samana_blue_logo.b9f64b42.png";